// extracted by mini-css-extract-plugin
export default {"sticky_nav":"InfoBar_sticky_nav__D66wJ"};